class SpoilerMedia extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    this.remove()
  }
}

if (!customElements.get('spoiler-media')) {
  customElements.define('spoiler-media', SpoilerMedia)
}
